import { Box, Flex } from '@chakra-ui/react';

import PieChart from '../../chart/PieChart';
import BarChart from '../../chart/BarChart';
import LineChart from '../../chart/LineChart';

import { BaseInstrumentProperties } from './proptypes';

export const ChartInstrument = ({ widget, output }: BaseInstrumentProperties) => {
  const timeGranularity =
    widget?.time_granularity === 'month' ? 'M' : widget?.time_granularity === 'quarter' ? 'Q' : 'Y';

  const displayChart = () => {
    switch (widget?.instrument_type) {
      // case 'pie':
      //   return (
      //     <PieChart chartFormatting={widget?.formatting} graphData={widget} />
      //     // <PieChart chartFormatting={widget?.formatting} />
      //   );
      case 'line':
        return (
          <LineChart
            timeGranularityFilter={timeGranularity}
            chartFormatting={widget?.formatting}
            graphData={output}
            isDashboardLayout={true}
          />
        );
      case 'bar':
        return (
          <BarChart
            timeGranularityFilter={timeGranularity}
            chartFormatting={widget?.formatting}
            graphData={output}
            isDashboardLayout={true}
          />
        );
      case 'stack':
        return (
          <BarChart
            timeGranularityFilter={timeGranularity}
            chartFormatting={{ ...widget?.formatting, stackBar: true }}
            graphData={output}
            isDashboardLayout={true}
          />
        );
      default:
        return <PieChart />;
    }
  };

  return (
    <Flex borderRadius='15px' flexDirection='column' height='100%'>
      <Flex justifyContent='center' alignItems='center' height='100%'>
        <Box
          className='dashboard-drag-header'
          cursor='grab'
          width={['bar', 'line', 'stack'].includes(widget?.instrument_type) ? '95%' : ''}
          height={['bar', 'line', 'stack'].includes(widget?.instrument_type) ? '97%' : ''}
        >
          {displayChart()}
        </Box>
      </Flex>
    </Flex>
  );
};

export default ChartInstrument;
